import { ENV } from "../utils";

export class Source {
  baseApi = ENV.BASE_API;

  async getSources(accessToken, active = true) {
    const url = `${this.baseApi}/sources?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createSource(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-source`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateSource(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-source/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteSource(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-source/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
